import React from 'react';
import { makeStyles,  createStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    subtitle: {
      textDecoration: 'underline'
    },
    annotation: {
      fontSize: '0.75rem',
      marginBottom: '5px',
    },
    bold: {
      fontWeight: 'bold',
    },
  }),
);

/** サービス概要の英語版本文。 */
const EN: React.FC = () => {
  const classes = useStyles();
  return (
    <div>
      <h3 className={classes.subtitle}>About this service</h3>
      <p>This is a limousine and taxi dispatch booking service based on email. You can book a limousine or taxi dispatch “to the airport from your specified location” or “from the airport to your specified location” as selected on a map, based on the airport and airline you are using. </p>
      <p className={classes.annotation}>* Partnerships with limousine and taxi dispatch service companies will be expanded successively.</p>
      <h3 className={classes.subtitle}>Recommended environment</h3>
      {/* PC環境 */}
      <Typography className={classes.bold}>・PC</Typography>
      <Typography className={classes.bold}>Windows (excluding Windows RT)</Typography>
      <Typography>Latest version of Google Chrome</Typography>
      <Typography>Latest version of Microsoft Edge</Typography>
      <Typography className={classes.bold}>Macintosh</Typography>
      <Typography gutterBottom>Latest version of Google Chrome</Typography>
      {/* スマートフォン・タブレット環境 */}
      <Typography className={classes.bold}>・Smartphone/Tablet</Typography>
      <Typography className={classes.bold}>iOS</Typography>
      <Typography>Latest version of Safari</Typography>
      <Typography className={classes.bold}>Android browsers</Typography>
      <Typography gutterBottom>Latest version of Google Chrome</Typography>
      {/* 注釈 */}
      <Typography className={classes.annotation}>
        *Even if your device fulfils the relevant system requirements, some pages may be displayed incorrectly and certain functions may be unavailable for reasons such as your combination of browser and OS. (This also includes the use of some add-ons and beta, preview, or other such browser versions.)
      </Typography>
      <Typography className={classes.annotation}>
        *Although we are always looking into how we can make our website compatible with new browsers, there may be occasions when pages will not display or function correctly due to unique issues with browsers that are yet to be officially released.
      </Typography>
      <h3 className={classes.subtitle}>About shown estimate of travel distance and time</h3>
      <p>The system calculates the estimated driving distance and travel time based on the coordinates you select on the map. To obtain and show the travel time, the system factors in predicted congestion based on the time the limousine taxi is booked for. However, please keep in mind that it may differ from the actual travel time due to the road situation, etc.</p>
      <p>* Source of map information: Google</p>
    </div>
  );
}

export default EN;
